<ng1-profile-groups [selectedPerson]="selectedPerson"
                    [isOrganisationAdmin]="isOrganisationAdmin"
                    [isStaff]="isStaff"></ng1-profile-groups>
